import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import Vuex from 'vuex'
import store from './store/store.js'

// Vue.prototype.$bus = this



Vue.use(Vuex)
// Electron 环境：注入 ipc / fs（网页版不会进入）
try {
	if (typeof window !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('electron/') !== -1) {
		const electron = window.require('electron')
		Vue.prototype.$electron = electron
		Vue.prototype.$nodeFs = window.require('fs')
		Vue.prototype.userDirectory = window.require('os').homedir().replace(/\\/g, '/') + '/zbt_loginInfo.json'
		Vue.prototype.$isElectron = true
		console.log('Electron 环境已启用, userDirectory:', Vue.prototype.userDirectory)
	} else {
		Vue.prototype.$isElectron = false
	}
} catch (e) {
	Vue.prototype.$isElectron = false
	console.warn('非 Electron 环境或 require 不可用', e && e.message)
}
import './theme/normalFont.css'

// var i = 1
// if (i === 1) {
// 	import('./theme/theme1.css')
// } else {
// 	import('./theme/theme2.css')
// }

//1、socketIO通信机制
//import VueSocketIO from 'vue-socket.io'
// import socketio from 'socket.io-client'
// Vue.use(new VueSocketIO({
// 	debug:true,
// 	connection: 'ws://192.168.0.151:8000/WS-SERVER/websocket'//'ws://115.159.45.116:8000/WS-SERVER/websocket' 
// }))

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)

import DGTable from './views/reportform/index.js'
Vue.use(DGTable)

import axios from 'axios'
Vue.prototype.axios = axios

import JwChat from '@/components'
Vue.use(JwChat)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.config.productionTip = false

//引入公共js文件
import util from "./utils/util.js"
Vue.prototype.util = util


// import drag from './utils/drag.js'
// Vue.use(drag);

Vue.filter('dateFormat', function (originVal) {
	// 先把传参秒转化为new Date()
	let minutes = Math.floor(originVal / 60);
	let seconds = Math.round(originVal % 60);
	return minutes + "分钟 " + seconds + "秒 ";
})


router.beforeEach((to, from, next) => {

	let isLogin = util.getLoginTip()
	if (from.name === null && to.name === 'home') {
		if (isLogin === '0') {
			next({ path: '/' })
		}
	}

	if (from.name === null && to.name === 'setting') {
		if (isLogin === '0') {
			next({ path: '/' })
		}
	}

	if (to.meta.title) {
		document.title = to.meta.title
	}
	if (to.query.name) {
		document.title = to.query.name
	}
	next();
})

new Vue({
	router: router,
	store,
	render: h => h(App),
}).$mount('#app')
